import * as React from "react"

const SvgChatMessage = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m6 18.286-2.3 2.3q-.476.474-1.088.212T2 19.861V4.286q0-.825.587-1.413A1.93 1.93 0 0 1 4 2.286h16q.824 0 1.413.587.587.588.587 1.413v12q0 .825-.587 1.412a1.93 1.93 0 0 1-1.413.588zm-.85-2H20v-12H4V17.41l1.15-1.125Z" />
  </svg>
)
export default SvgChatMessage
